import { cleanParams } from "../../../shared/api/common"
import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildPriceUrl = (endpoint = "") =>
  `${API_ROUTES.TRANSFER.BASE}/${API_ROUTES.TRANSFER.PRICES}${endpoint ? `/${endpoint}` : ""}`

const buildPricePhotoUrl = (id) => `${API_ROUTES.TRANSFER.BASE}/price_photos/${id}`

export const transferPricesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPriceFormData: builder.query({
      query: ({ id, from_id, transport_type_id, copy } = {}) => ({
        url: buildPriceUrl("form_data"),
        method: "GET",
        params: cleanParams({ id, from_id, transport_type_id, copy }),
      }),
      keepUnusedDataFor: 0,
    }),

    getPriceResorts: builder.query({
      query: ({ state_id }) => ({
        url: buildPriceUrl("resorts"),
        method: "GET",
        params: cleanParams({ state_id }),
      }),
    }),

    savePrice: builder.mutation({
      query: ({ id, body }) => ({
        url: buildPriceUrl(id),
        method: id ? "PATCH" : "POST",
        body,
        headers: {
          Accept: "application/json",
        },
      }),
    }),

    deletePricePhoto: builder.mutation({
      query: ({ id }) => ({
        url: buildPricePhotoUrl(id),
        method: "DELETE",
        headers: {
          Accept: "application/json",
        },
      }),
    }),

    getPricesGrid: builder.query({
      query: (params) => ({
        url: buildPriceUrl("grid"),
        method: "GET",
        params: cleanParams(params),
      }),
    }),

    deletePrices: builder.mutation({
      query: ({ ids }) => ({
        url: buildPriceUrl("destroy_multiple"),
        method: "DELETE",
        body: { price_ids: ids },
        headers: {
          Accept: "application/json",
        },
      }),
    }),
  }),
})

export const {
  useGetPriceFormDataQuery,
  useLazyGetPriceResortsQuery,
  useSavePriceMutation,
  useDeletePricePhotoMutation,
  useGetPricesGridQuery,
  useDeletePricesMutation,
} = transferPricesService
